<template>
  <transition class="font-poppins" name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal w-1/3 md:w-full rounded-lg"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header
          class="modal-header text-center"
          id="modalTitle"
        >
          <slot name="header">
            Confirm
          </slot>
          <button
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
            x
          </button>
        </header>

        <section
          class="modal-body text-center "
          id="modalDescription"
        >
          <slot name="body">
            {{message}} {{firstName}} {{lastName}}
          </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            
          </slot>
          <div class="flex">
            <button
                type="button"
                class="bg-blue-700 text-white w-1/2 text-center rounded-lg"
                @click="updateCashPayment"
                aria-label="Close modal"
            >
                YES
            </button>
            <button
                type="button"
                class="bg-white border p-2 rounded-lg w-1/2"
                @click="close"
                aria-label="Close modal"
            >
                NO
            </button>
          </div>
          
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
  export default {
    name: 'Modal',
    props: [
      "id",
      "firstName",
      "lastName",
      "cashPaymentStatus",
      "message",
    ],
    data() {
      return {
        type: "cash",
        status: Boolean,
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },

      updateCashPayment() {
        if (this.cashPaymentStatus == false) {
          this.status = true;
        } else {
          this.status = false;
        }
          axios({
              method: 'PUT',
              url: `${url}/v1/web/users/payment/toggle`,
              headers: {
                  'Content-type': 'application/json',
                  Authorization: 'Bearer' + localStorage.getItem("token"),
                  'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
              },
              data : {
                userId: this.id,
                type: this.type,
                status: this.status
              }
              
          })
          .then((res)=>{
            res.json;
            this.close();
          })
          .catch((err) =>err.json)
      }
    },
  };
</script>

<style scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>